// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b4a2f6a3","239":"b67fbdf4","331":"8d2a9702","598":"3f0dc675","622":"ca383a6b","787":"e98a8684","977":"1bb12ded"}[chunkId] + ".chunk.js";
};